<template>
  <v-list :two-line="true">
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title v-text="$t('monitoring.info.process')" />
        <v-list-item-subtitle v-text="process.processType" />
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title :class="Utils.getIconColor(process.resultStatus) + '--text'">
          {{ $t('monitoring.status') }}
          <v-icon :color="Utils.getIconColor(process.resultStatus)" v-html="Utils.getIcon(process.resultStatus)" />
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title v-text="$t('monitoring.info.start_date')" />
        <v-list-item-subtitle v-text="process.startDateTime" />
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title v-text="$t('monitoring.info.end_date')" />
        <v-list-item-subtitle v-text="process.endDateTime" />
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-btn color="primary" v-text="$t('monitoring.details.copy_link')" @click="copyURL" />
    </v-list-item>
    <v-list-item>
      <RefreshButton @click="$emit('refresh')" />
    </v-list-item>
    <v-list-item>
      <GoBackButton />
    </v-list-item>
  </v-list>
</template>
<script>
import Utils from '../../utils'
import RefreshButton from '../RefreshButton.vue'
import GoBackButton from '../GoBackButton.vue'

export default {
  name: 'Info',
  data: () => ({ Utils }),
  props: {
    process: Object
  },
  methods: {
    copyURL () {
      const actualURL = window.location.href
      navigator.clipboard.writeText(actualURL)
    }
  },
  components: { RefreshButton, GoBackButton }
}
</script>
